import "ngstorage";

const GRACE_PERIOD = 1000 * 60 * 60 * 24 * 3;

export default class EventsService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, TrackingService, $timeout) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$tracking = TrackingService;
    this.current_event = null;
    this.currentEventId = null;
    this.$timeout = $timeout;

    this.development_env = this.$env.getEnv();
    console.log("this.development_env", this.development_env);
  }

  get_history(params) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      params.companyId +
      "/listInvoices?format=json&isClosed=" +
      params.isClosed +
      "&max=" +
      params.max +
      "&offset=" +
      params.offset +
      "&order=" +
      params.order +
      "&sort=" +
      params.sort +
      "&isCancelled=false";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      async: false,
      data: {}
    };
    return this.$http(req);
  }

  get_event() {
    return this.current_event;
  }

  set_event(event) {
    this.current_event = event;
  }

  getEventById(event_id) {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?conf=web&format=json&max=1&order=desc&sort=lastUpdated&verbosity=5";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getPendingApplications(subEventId, maxCount = 6, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&conf=web&status=3&max=" +
      maxCount.toString() +
      "&offset=" +
      offset +
      "&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.phoneMobile,applicant.homeContactInfo.state";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getAcceptedApplications(subEventId, maxCount = 200, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&verbosity=4&conf=web&max=" +
      maxCount +
      "&status=1&offset=" +
      offset +
      "&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.username,jobble.id,applicant.id";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };

    return this.$http(req);
  }

  notifyJobblers(info) {
    var _this = this;

    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/notify-pool?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        id: info.id,
        visibility: info.visibility
      }
    };

    return this.$http(req);
  }

  notifyBusinessOfInterestedReference(rid) {
    var _this = this;

    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "public/userReferences/references/" + rid + "/follow-up",
      headers: {
        "Content-Type": "application/json"
      },
      data: {}
    };

    return this.$http(req);
  }

  createEvent(eventObj) {
    console.log("in create event");
    console.dir(eventObj);
    var jobbleForDB = {
      name: eventObj.name,
      payPerHour: parseInt(eventObj.hourly_rate * 100),
      description: eventObj.jobble_details,
      dressCode: eventObj.dress_code,
      jobbleType: eventObj.jobble_type,
      isPublished: true,
      manager: eventObj.manager,
      subEvent: {
        name: eventObj.name,
        contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
        event: {
          name: eventObj.name,
          description: eventObj.jobble_details,
          eventType: 1,
          timeToHire: eventObj.timeToHire,
          company: this.$auth.getUserData().company.id,
          surveyQuestions: eventObj.questions
        }
      },

      shifts: []
    };

    if (eventObj.orderNumber) {
      jobbleForDB.subEvent.event.orderNumber = eventObj.orderNumber;
    }

    if (eventObj.typeOfJobPosting === "source" || eventObj.isSourcingPost === true) {
      jobbleForDB.subEvent.event.isSourcingPost = true;
      if (eventObj.isClone === true) {
        jobbleForDB.subEvent.event.isPublished = true;
        jobbleForDB.subEvent.event.surveyQuestions.forEach(function (q) {
          q.editing = false;
        });
      }
    } else {
      jobbleForDB.subEvent.event.isSourcingPost = false;
    }

    for (var i = 0; i < eventObj.timeIntervalsArray.length; i++) {
      var shift = {
        timeInterval: {
          startTime: eventObj.timeIntervalsArray[i].startDateAndTimeForDB,
          endTime: eventObj.timeIntervalsArray[i].endDateAndTimeForDB
        },
        contactInfo: eventObj.timeIntervalsArray[i].contactInfo
      };

      console.log("ktrack33");
      console.dir(shift);
      jobbleForDB.shifts.push(shift);
    }

    if (eventObj.postIsPrivate && eventObj.cloudsForJobblePost.length === 0) {
    } else {
      var savingSingleJobbleToDB = {};
      if (eventObj.postIsPrivate) {
        console.log("were in this bracket.............1");
        /*
			  addToCircle : {
				  forCircleOnly : false,
				  circles :  eventObj.cloudsForJobblePost
			  }
			  */
        savingSingleJobbleToDB = {
          method: "POST",
          url:
            this.$env.getAPIEndPoint() +
            "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" +
            eventObj.openings +
            "&fields=id,subEvent.id,subEvent.event.id",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$auth.getAccessToken()
          },
          data: {
            jobble: jobbleForDB
          }
        };
      } else {
        if (eventObj.cloudsForJobblePost.length === 0) {
          console.log("were in this bracket.............2");
          savingSingleJobbleToDB = {
            method: "POST",
            url:
              this.$env.getAPIEndPoint() +
              "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=1&numberPosition=" +
              eventObj.openings +
              "&fields=id,subEvent.id,subEvent.event.id",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$auth.getAccessToken()
            },
            data: {
              jobble: jobbleForDB
            }
          };
        } else {
          /*
				     addToCircle : {
						  forCircleOnly : false,
						  circles :  eventObj.cloudsForJobblePost
					  }
				   */
          console.log("were in this bracket.............3");

          savingSingleJobbleToDB = {
            method: "POST",
            url:
              this.$env.getAPIEndPoint() +
              "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" +
              eventObj.openings +
              "&fields=id,subEvent.id,subEvent.event.id",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$auth.getAccessToken()
            },
            data: {
              jobble: jobbleForDB
            }
          };
        }
      }
    }

    return this.$http(savingSingleJobbleToDB);
  }

  setCurrentEventId(eventId) {
    this.currentEventId = eventId;
  }

  getCurrentEventId() {
    return this.currentEventId;
  }

  trackNoShow(application, event) {
    var _this = this;
    var jobbleTypeName = event.subEvents[0].deduppedJobbles[0].jobbleType.name;
    _this.$tracking.reportNoShows(application, jobbleTypeName);
  }

  trackShifts(applications, event, user) {
    var _this = this;
  }

  trackEventCompletion(applications, event, total, user) {
    var _this = this;
    var data = {};
    _this.trackShifts(applications, event, user);
    data.jobbleTypeName = event.subEvents[0].deduppedJobbles[0].jobbleType.name;
    data.payPerHourInCents = event.subEvents[0].deduppedJobbles[0].payPerHour;
    data.totalMoney = total;
    data.revenueLost = 0;
    data.noShowCount = 0;
    data.removedFromPaymentCount = 0;
    data.hiredJobblersCount = applications.length;
    data.totalNumberOfOpenings = event.numberOfOpenings + data.hiredJobblersCount;
    data.openingsLeft = event.numberOfOpenings;
    data.user = user.email;
    data.companyName = event.company.name;
    data.companyId = event.company.id;
    if (data.user.indexOf("jobble.com") !== -1 || data.user.indexOf("jobbleapp.com") !== -1) {
      data.isJobbleAdmin = true;
    } else {
      data.isJobbleAdmin = false;
    }
    data.fillRatePercentageBeforeNoShows = Math.round((data.hiredJobblersCount / data.totalNumberOfOpenings) * 100);
    try {
      applications.forEach(function (application) {
        if (application.jobble.noShow) {
          _this.trackNoShow(application, event);
          if (application.jobble.actualRevenue) {
            data.revenueLost = data.revenueLost + application.jobble.actualRevenue;
          } else {
            data.revenueLost = data.revenueLost + application.jobble.costOfJobble;
          }
          data.noShowCount++;
        } else {
          if (application.strikeOutClass) {
            data.removedFromPaymentCount++;
          }
        }
      });
    } finally {
      data.revenueLostRounded = (data.revenueLost / 100).toFixed(2);
      data.fillRatePercentageAfterNoShows = Math.round(((data.hiredJobblersCount - data.noShowCount) / data.totalNumberOfOpenings) * 100);
      data.potentialGMV = (parseFloat(data.totalMoney) + parseFloat(data.revenueLostRounded)).toFixed(2);
      _this.$timeout(function () {
        data.potentialGMV = data.potentialGMV.toString();
        data.revenueLostRounded = data.revenueLostRounded.toString();
        data.totalMoney = data.totalMoney.toString();
        console.log("reporting job pay out");
        _this.$tracking.reportJobPayOut(data);
      }, 1000);
    }
  }

  payJobblersAndCloseEvent(applications, subeventId, cardToken, eventId, payType, delivery, user) {
    let transferArray = [];
    let responseForController = null;

    try {
      applications.forEach(function (application) {
        if (application.isCheckedForAction) {
          if (!application.paymentToshiftHasBeenMade || application.paymentToshiftHasBeenMade === false) {
            if (application.jobble.noShow !== true && application.strikeOutClass !== "strike-out-jobbler") {
              if (delivery) {
                let transferObj = {
                  recipient: application.applicant.username,
                  amount: application.jobble.payPerHour,
                  jobble: application.jobble.id,
                  note: "Jobble Web App payment"
                };
                transferArray.push(transferObj);
              } else {
                if (application.jobble.actualMinutesWorked !== 0 || application.jobble.no_show_cancelled === true) {
                  if (application.jobble.actualMinutesWorked && application.jobble.actualMinutesWorked !== 0) {
                    let totalCostForJobble = Math.round((application.jobble.actualMinutesWorked * application.jobble.payPerHour) / 60);
                    let transferObj = {
                      recipient: application.applicant.username,
                      amount: totalCostForJobble,
                      jobble: application.jobble.id,
                      note: "Jobble Web App payment"
                    };
                    transferArray.push(transferObj);
                  } else {
                    let totalCostForJobbleNotEdited = Math.round((application.jobble.jobbleDurationInMinutes * application.jobble.payPerHour) / 60);
                    let transferObj = {
                      recipient: application.applicant.username,
                      amount: totalCostForJobbleNotEdited,
                      jobble: application.jobble.id,
                      note: "Jobble Web App payment"
                    };
                    transferArray.push(transferObj);
                  }
                } else {
                  console.log("jobble actual minutes are 0...");
                  console.dir(application);
                }
              }
            }
          }
        } else {
          console.log("user not checked.");
        }
        console.log("--------------------------application in events.js---------------------------------");
      });
    } catch (err) {
      console.log("some error in the loop");
      console.dir(err);
    } finally {
      var eventIdForClosure = eventId.toString();

      var payTheJobblers = null;

      if (user.company.payByInvoice === true) {
        payTheJobblers = {
          method: "POST",
          url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$auth.getAccessToken()
          },
          data: {
            transfers: transferArray
          }
        };
      } else {
        if (payType === "bank") {
          payTheJobblers = {
            method: "POST",
            url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$auth.getAccessToken()
            },
            data: {
              transfers: transferArray,
              bank: cardToken
            }
          };
        } else {
          payTheJobblers = {
            method: "POST",
            url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$auth.getAccessToken()
            },
            data: {
              transfers: transferArray,
              card: cardToken
            }
          };
        }
      }
    }

    return this.$http(payTheJobblers);
  }

  closeEvent(eventId) {
    var _this = this;

    let data = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/close-event?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },

      data: {events: [eventId]}
    };

    return this.$http(data);
  }

  getLatLngOfAddress(shift) {
    console.log("give me the address");
    console.dir(shift);
  }

  checkJobblerInOrOut(data, type) {
    var url;

    if (type === 1) {
      url = "jbl/v1/jobbles/bulk-checkin?format=json";
    } else {
      url = "jbl/v1/jobbles/bulk-checkout?format=json";
    }

    var checkInJobblers = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data
    };

    return this.$http(checkInJobblers);
  }

  getEventByIdTrimmedMessaging(event_id) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,isChannelDeleted,autoAccept,autoManage,startTime,name,contactInfo.state,contactInfo.city,contactInfo.streetLine1,contactInfo.zipCode,subEvents.id,subEvents.deduppedJobbles.manager.id,subEvents.deduppedJobbles.shifts.timeInterval.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.timeInterval.endTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTimeFormattedLoc,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getEventByIdTrimmedComplete(event_id, x) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,name,isSourcingPost,numberOfOpenings,orderNumber,endTime,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobbleType.fileJOBBLE_TYPE_FILE01IMG_800x800,subEvents.deduppedJobbles.jobbleType.picture1,firstInvoices,subEvents.deduppedJobbles.jobbleType.name,isClosed,isCancelled,isCompleted,subEvents.id,company.id,company.name,contactInfo.city,contactInfo.state,contactInfo.streetLine1,contactInfo.zipCode";

    if (x === 1) {
      url = url + ",surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType";
    }

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getEventByIdTrimmedv2(event_id, x) {
    var url = this.$env.getAPIEndPoint() + "jbl/v1/events/details/" + event_id;

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getEventByIdTrimmedCreation(event_id, x) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,startTime,isLongTerm,weeks,dateCreated,autoAccept,autoManage,arrivalInstructions,onsiteManagerName,onsiteManagerNumber,originalOpenings,endTime,isClosed,isCompleted,isCancelled,name,description,totalNumberOfJobbles,numberOfOpenings,subEvents.description,subEvents.deduppedJobbles.description,subEvents.unpaidBreak,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.name,subEvents.deduppedJobbles.startTimeFormattedLoc,subEvents.deduppedJobbles.endTimeFormattedLoc,subEvents.deduppedJobbles.jobbleType.name,eventManager,subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.forCircleOnly,subEvents.deduppedJobbles.manager.id,subEvents.deduppedJobbles.dropoffContactInfo,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.contactInfo.place.rawOffset,subEvents.deduppedJobbles.manager.firstName,subEvents.deduppedJobbles.manager.lastName,subEvents.deduppedJobbles.manager.email,subEvents.deduppedJobbles.manager.homeContactInfo.phoneMobile,subEvents.deduppedJobbles.dressCode,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.shiftPosition,subEvents.deduppedJobbles.shifts.padding,subEvents.deduppedJobbles.shifts.location,subEvents.deduppedJobbles.shifts.timeInterval.id,subEvents.deduppedJobbles.shifts.timeInterval.endTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.lat,subEvents.deduppedJobbles.shifts.contactInfo.lng,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.timeZoneName,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.isPublished,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.id,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.unpaidBreak,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobblerRate,subEvents.deduppedJobbles.jobbleDurationInMinutes,subEvents.id,subEvents.deduppedJobbles.circles.name,subEvents.deduppedJobbles.currentLocation.lat,subEvents.deduppedJobbles.currentLocation.lng,subEvents.deduppedJobbles.currentLocation.lastUpdateFront,subEvents.deduppedJobbles.jobblePoolId";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getEventByIdTrimmed(event_id, x) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,startTime,isLongTerm,weeks,dateCreated,autoAccept,autoManage,arrivalInstructions,onsiteManagerName,onsiteManagerNumber,isChannelDeleted,originalOpenings,endTime,isOrder,orderNumber,isSourcingPost,isClosed,isCompleted,isCancelled,name,description,totalNumberOfJobbles,numberOfApprovedApplications,numberOfOpenings,subEvents.description,subEvents.deduppedJobbles.description,subEvents.deduppedJobbles.pickupTime,subEvents.deduppedJobbles.dropoffTime,subEvents.deduppedJobbles.dropoffAddress,subEvents.deduppedJobbles.pickupAddress,subEvents.unpaidBreak,subEvents.deduppedJobbles.pickupLocation,subEvents.deduppedJobbles.dropoffLocation,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.name,subEvents.deduppedJobbles.startTimeFormattedLoc,subEvents.deduppedJobbles.endTimeFormattedLoc,subEvents.deduppedJobbles.jobbleType.name,eventManager,subEvents.deduppedJobbles.jobbleType.picture1,subEvents.deduppedJobbles.jobbleType.picture1,subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.forCircleOnly,subEvents.deduppedJobbles.manager.id,subEvents.deduppedJobbles.dropoffContactInfo,subEvents.deduppedJobbles.pickupContactInfo,subEvents.deduppedJobbles.shifts.deliveryContactInfo,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.contactInfo.place.rawOffset,subEvents.deduppedJobbles.manager.firstName,subEvents.deduppedJobbles.manager.lastName,subEvents.deduppedJobbles.manager.email,subEvents.deduppedJobbles.manager.homeContactInfo.phoneMobile,subEvents.deduppedJobbles.dressCode,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.shiftPosition,subEvents.deduppedJobbles.shifts.description,subEvents.deduppedJobbles.shifts.padding,subEvents.deduppedJobbles.shifts.location,subEvents.deduppedJobbles.shifts.timeInterval.id,subEvents.deduppedJobbles.shifts.timeInterval.endTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.lat,subEvents.deduppedJobbles.shifts.contactInfo.lng,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.timeZoneName,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.isPublished,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.id,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.unpaidBreak,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobblerRate,subEvents.deduppedJobbles.jobbleDurationInMinutes,subEvents.id,subEvents.deduppedJobbles.circles.name,numberOfPendingApplications,subEvents.deduppedJobbles.shifts.pickupEta,subEvents.deduppedJobbles.shifts.dropoffEta,subEvents.deduppedJobbles.currentLocation.lat,subEvents.deduppedJobbles.currentLocation.lng,subEvents.deduppedJobbles.currentLocation.lastUpdateFront,subEvents.deduppedJobbles.jobblePoolId,numberOfRejectedApplications,numberOfQuitApplications,numberOfWithdrawnApplications,surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType,surveyQuestions.displayOrder";

    if (x === 1) {
      url = url + ",surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType,surveyQuestions.displayOrder";
    }

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getEventByIdWithFields(event_id, fields) {
    //var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=" + fields;
    var url = this.$env.getAPIEndPoint() + "jbl/v1/eventsNew/" + event_id;

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getEventCompanyDescription() {
    var _this = this;

    var req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&conf=web&fields=company.description&aclProcess=false&marshal=false",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return _this.$http(req);
  }

  saveEventCompanyDescription(description) {
    const req = {
      method: "PUT",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        this.$auth.getUserData().id +
        "?format=json&fields=company.description&aclProcess=false&marshal=false",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        company: {
          description
        }
      }
    };

    return this.$http(req);
  }

  getEventByIdTrimmedLive(event_id) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,isClosed,isCancelled,isCompleted,numberOfApprovedApplications,startTime,endTime,subEvents.id,name,contactInfo.state,contactInfo.city,contactInfo.streetLine1,contactInfo.zipCode,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.checkInTime,subEvents.deduppedJobbles.shifts.checkOutTime";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getEventByIdTrimmedRoster(event_id) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,isClosed,isCancelled,numberOfApprovedApplications,isSourcingPost,isCompleted,startTime,subEvents.id,name,contactInfo.state,contactInfo.city,contactInfo.streetLine1,contactInfo.zipCode,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.position,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.jobbleType.fileJOBBLE_TYPE_FILE01IMG_800x800,subEvents.deduppedJobbles.jobbleType.picture1,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.shifts.callToAction,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.jobbleType.name,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.streetLine";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getEventByIdTrimmedTimesheet(event_id) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,startTime,subEvents.id,name,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.contactInfo.timeZoneName,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.checkInTime,subEvents.deduppedJobbles.shifts.checkOutTime";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getEventByIdTrimmedInvoice(event_id, x) {
    console.log("getEventByIdTrimmedInvoice");
    console.dir(event_id);
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/events/" +
      event_id +
      "?format=json&fields=id,startTime,endTime,subEvents.deduppedJobbles.jobbleDurationInMinutes";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedMessaging(subEventId, maxCount = 200, offset = 0) {
    // var url = this.$env.getAPIEndPoint() + 'jbl/v1/subevents/' + subEventId + '/applications?format=json&conf=web&max=5&status=1';

    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&status=1&fields=id,applicant.firstName,jobble.id,applicant.emailChatNotificationOn,applicant.smsChatNotificationOn,applicant.lastName,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.id,applicant.email";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getAcceptedApplicationsTrimmed(subEventId, maxCount = 200, offset = 0) {
    // var url = this.$env.getAPIEndPoint() + 'jbl/v1/subevents/' + subEventId + '/applications?format=json&conf=web&max=5&status=1';

    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&status=1&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.picture1s,applicant.id";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedRoster(subEventId, max) {
    // var url = this.$env.getAPIEndPoint() + 'jbl/v1/subevents/' + subEventId + '/applications?format=json&conf=web&max=5&status=1';

    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&offset=0&max=100&status=1&fields=id,dateCreated,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.email,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.id,jobble.shifts.id,jobble.shifts.shiftPosition,jobble.shifts.managerCheckInTime,jobble.shifts.managerCheckOutTime,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime,jobble.shifts.contactInfo.place.timeZoneId,jobble.shifts.contactInfo.place.rawOffset,jobble.shifts.confirmationResponse,jobble.shifts.confirmationSource,jobble.shifts.confirmationNote,jobble.shifts.confirmationDateTime";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getAcceptedApplicationsRosterManagement(subEventId, max) {
    const url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&offset=0&max=100&status=1&fields=id,dateCreated,applicant.id,jobble.id,jobble.shifts.id,jobble.shifts.shiftPosition,jobble.shifts.managerCheckInTime,jobble.shifts.managerCheckOutTime,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.autoCheckInCoord.lat,jobble.shifts.autoCheckInCoord.lng,jobble.shifts.autoCheckOutCoord.lat,jobble.shifts.autoCheckOutCoord.lng,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.confirmationResponse,jobble.shifts.confirmationSource,jobble.shifts.confirmationNote,jobble.shifts.jobblerNote,jobble.shifts.confirmationDateTime,jobble.shifts.actualMinutesWorked,jobble.shifts.noShow,jobble.shifts.paymentStats,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime";

    const req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getShiftInformationComplete(subEventId, application) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications/" +
      application.id +
      "?format=json&fields=jobble.shifts.id,jobble.shifts.paymentStats,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.noShow,jobble.shifts.contactInfo.place.timeZoneId,jobble.shifts.contactInfo.place.timeZoneName,jobble.shifts.contactInfo.city,jobble.shifts.contactInfo.state,jobble.shifts.contactInfo.zipCode,jobble.shifts.contactInfo.streetLine1,jobble.shifts.actualMinutesWorked,jobble.shifts.timeInterval.id,jobble.shifts.timeInterval.endTime,jobble.shifts.timeInterval.startTime,jobble.shifts.jobblerNote,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckInCoord.lat,jobble.shifts.autoCheckInCoord.lng,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.autoCheckOutCoord.lat,jobble.shifts.autoCheckOutCoord.lng";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedComplete(subEventId, maxCount, offset) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&offset=" +
      offset +
      "&status=1&fields=applicant.username,jobble.subEvents.id,applicant.email,jobble.id,jobble.makeAdditionalPayment,jobble.startTime,jobble.endTime,id,applicant.firstName,applicant.lastName,applicant.age,applicant.gender,applicant.dateBirth,applicant.averageRatingReceived,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.actualMinutesWorked,jobble.noShow,jobble.jobbleDuration,jobble.jobbleDurationInMinutes,jobble.actualRevenue,jobble.jobblePoolId,jobble.payPerHour,jobble.costOfJobble,rating.id,rating.value,rating.rate,jobble.paymentStats,jobble.shifts.jobblerNote,jobble.shifts.id,jobble.shifts.paymentStats,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.autoCheckInCoord,jobble.shifts.autoCheckOutCoord,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.undeletedPaymentInfos.id";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedCompleteTracking(subEventId, maxCount = 200, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&status=1&fields=applicant.username,applicant.email,jobble.id,applicant.id,jobble.noShow,jobble.shifts.jobblerNote,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckInCoord.lat,jobble.shifts.autoCheckInCoord.lng,jobble.shifts.id,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.autoCheckOutCoord.lat,jobble.shifts.autoCheckOutCoord.lng,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng,jobble.shifts.checkOutTime,jobble.shifts.checkOutCoord.lat,jobble.shifts.timeInterval.startTime,jobble.shifts.contactInfo.city,jobble.shifts.contactInfo.state,jobble.shifts.contactInfo.streetLine1,jobble.shifts.contactInfo.zipCode,jobble.shifts.noShow";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedLive(subEventId, maxCount = 200, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&status=1&fields=applicant.username,jobble.subEvents.id,applicant.email,jobble.id,jobble.startTime,jobble.endTime,id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.actualMinutesWorked,jobble.noShow,jobble.jobbleDuration,jobble.jobbleDurationInMinutes,jobble.actualRevenue,jobble.payPerHour,jobble.costOfJobble,rating.id,rating.value,rating.rate,jobble.paymentStats,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  checkForOverlaps(data) {
    /*{jobblesAndUsers: [{jobbleId:48354725,userId:168,appId:5915},{jobbleId:48354726,userId:170,appId:5917}]}*/

    let userId = data[0].userId;
    let jobbleId = data[0].jobbleId;

    var url = this.$env.getAPIEndPoint() + "jbl/v1/users/" + userId + "/jobbles/" + jobbleId + "/checkOverlap?format=json";

    var req = {
      method: "PUT",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {jobblesAndUsers: data}
    };

    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedReview(subEventId, maxCount, offset) {
    if (!offset) {
      offset = 0;
    }

    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&offset=" +
      offset +
      "&status=1&fields=id,applicationStatus.id,applicationStatus.name,hasOverlap,applicant.firstName,applicant.lastName,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.averageRatingReceived,applicant.isVerified,applicant.username,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.id,jobble.id,applicant.homeContactInfo.phoneMobile,applicant.numberOfCompletedJobbles,jobble.jobblePool.id,applicant.undeletedPaymentInfos.id";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getPendingApplicationsTrimmedReview(subEventId, maxCount, offset) {
    if (!offset) {
      offset = 0;
    }
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&offset=" +
      offset +
      "&status=3&isApplicantVerified=true&conf=web&fields=id,applicationStatus.id,applicationStatus.name,applicant.firstName,hasOverlap,applicant.lastName,applicant.isDeleted,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.homeContactInfo.phoneMobile,applicant.isVerified,applicant.username,applicant.numberOfCompletedJobbles,applicant.undeletedPaymentInfos.id";
    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  getAllApplicants(jpid, max, offset, sort, order, multiSearch) {
    if (!offset) {
      offset = 0;
    }

    let url =
      this.$env.getAPIEndPoint() + "jbl/v1/applications/list-all?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";

    if (sort) {
      url += `&sort=${sort}`;
    }

    if (order) {
      url += `&order=${order}`;
    }

    if (multiSearch) {
      url += `&multiSearch=${encodeURIComponent(multiSearch)}`;
    }

    const req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  getPendingApplicationsTrimmedReview2(jpid, max, offset) {
    if (!offset) {
      offset = 0;
    }

    var url =
      this.$env.getAPIEndPoint() + "jbl/v1/applications/list-all?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  getRejectingApplicationsTrimmedReview(jpid, max, offset) {
    if (!max) {
      max = 10;
    }
    if (!offset) {
      offset = 0;
    }
    var url =
      this.$env.getAPIEndPoint() + "jbl/v1/applications/list-rejects?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  getQuitedApplicationsTrimmedReview(jpid, max, offset) {
    if (!max) {
      max = 10;
    }
    if (!offset) {
      offset = 0;
    }
    var url =
      this.$env.getAPIEndPoint() + "jbl/v1/applications/list-quitted?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  getWithdrawnApplicationsTrimmedReview(jpid, max, offset) {
    if (!max) {
      max = 10;
    }
    if (!offset) {
      offset = 0;
    }
    var url =
      this.$env.getAPIEndPoint() + "jbl/v1/applications/list-withdrawn?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";

    var req = {
      method: "GET",
      url: url,
      headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
      data: {}
    };
    return this.$http(req);
  }

  removeOpeningsToEvent(data, event, x) {
    var _this = this;

    var removeOpeningsData = {
      method: "POST",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        data.draftData.data.jobblePool.jobbles[0].id +
        "/rm-positions?format=json&conf=web&numberOfPositions=" +
        x,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return _this.$http(removeOpeningsData);
  }

  cloneEventv3(eventId) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + eventId + "/clone",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return _this.$http(req);
  }

  addOpeningsToEvent(data, event, x) {
    var _this = this;
    console.log("removeOpeningsToEvent");
    console.dir(data);
    console.dir(event);
    console.dir(x);
    var addOpeningsData = {
      method: "POST",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        data.draftData.data.jobblePool.jobbles[0].id +
        "/add-positions?format=json&conf=web&numberOfPositions=" +
        x,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return _this.$http(addOpeningsData);
  }

  roundPay(pay) {
    return Math.round(parseFloat(pay * 100));
  }

  saveDraft(params) {
    var _this = this;
    let eventObj = params.event;
    let is_sourcing_post = false;
    if (eventObj.typeOfJobPosting === "source") {
      is_sourcing_post = true;
    }
    let pay = _this.roundPay(eventObj.hourly_rate);
    var jobbleForDB = {
      name: eventObj.name,
      payPerHour: pay,
      description: eventObj.jobble_details,
      dressCode: eventObj.dress_code ? eventObj.dress_code : "Casual",
      jobbleType: eventObj.jobble_type,
      isPublished: false,
      manager: eventObj.manager,
      subEvent: {
        name: eventObj.name,
        contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
        event: {
          name: eventObj.name,
          description: eventObj.jobble_details,
          eventType: 1,
          isPublished: false,
          timeToHire: eventObj.timeToHire,
          company: this.$auth.getUserData().company.id,
          isSourcingPost: is_sourcing_post
        }
      },
      shifts: []
    };
    if (eventObj.typeOfJobPosting === "source") {
      jobbleForDB.subEvent.event.isSourcingPost = true;
    } else {
      jobbleForDB.subEvent.event.isSourcingPost = false;
    }
    try {
      for (var i = 0; i < eventObj.timeIntervalsArray.length; i++) {
        var shift = {
          timeInterval: {
            startTime: eventObj.timeIntervalsArray[i].startDateAndTimeForDB,
            endTime: eventObj.timeIntervalsArray[i].endDateAndTimeForDB
          },
          contactInfo: eventObj.timeIntervalsArray[i].contactInfo
        };
        jobbleForDB.shifts.push(shift);
      }
    } finally {
      var saveDraftObj = {
        method: "POST",
        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" + eventObj.openings,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$auth.getAccessToken()
        },
        data: {
          jobble: jobbleForDB
        }
      };
      return this.$http(saveDraftObj);
    }
  }

  saveDraftv2(event, cloneId) {
    let eventObj = event;

    console.log("saveDraftv2");
    console.dir(eventObj);

    let is_sourcing_post = eventObj.typeOfJobPosting === "source";
    let pay = this.roundPay(eventObj.hourly_rate);
    let company = this.$auth.getUserData() ? this.$auth.getUserData().company : {};

    var jobbleForDB = {
      name: eventObj.name,
      payPerHour: pay,
      description: eventObj.jobble_details,
      dressCode: eventObj.dress_code ? eventObj.dress_code : null,
      jobbleType: eventObj.jobble_type,
      arrivalInstructions: eventObj.arrival_instructions,
      onsiteManagerName: eventObj.onsite_manager_name,
      onsiteManagerNumber: eventObj.onsite_manager_number,
      isLongTerm: eventObj.is_long_term,
      weeks: eventObj.weeks,
      isPublished: false,
      manager: eventObj.manager,
      subEvent: {
        name: eventObj.name,
        contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
        event: {
          name: eventObj.name,
          description: eventObj.jobble_details,
          eventType: 1,
          isPublished: false,
          timeToHire: eventObj.timeToHire,
          company: company.id,
          isW2: event.isW2,
          isSourcingPost: is_sourcing_post,
          arrivalInstructions: eventObj.arrival_instructions,
          onsiteManagerName: eventObj.onsite_manager_name,
          onsiteManagerNumber: eventObj.onsite_manager_number,
          isLongTerm: eventObj.is_long_term,
          weeks: eventObj.weeks
        }
      },
      shifts: []
    };

    if (cloneId) {
      jobbleForDB.subEvent.event.cloneOf = cloneId;
    }

    jobbleForDB.subEvent.event.isSourcingPost = is_sourcing_post;

    let saveDraftObj;

    try {
      eventObj.timeIntervalsArray.map((timeInterval) => {
        const shift = {
          timeInterval: {
            startTime: timeInterval.startDateAndTimeForDB,
            endTime: timeInterval.endDateAndTimeForDB
          },
          contactInfo: timeInterval.contactInfo,
          overnight: timeInterval.overnight,
          unpaidBreak: timeInterval.unpaidBreak
        };
        jobbleForDB.shifts.push(shift);
      });
    } finally {
      console.log("jobbleForDB");
      console.dir(jobbleForDB);

      saveDraftObj = {
        method: "POST",
        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" + eventObj.openings,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$auth.getAccessToken()
        },
        data: {
          jobble: jobbleForDB
        }
      };
    }

    return this.$http(saveDraftObj);
  }

  addShiftRequirement(eventId, id, position) {
    const data = {
      method: "POST",
      url: `${this.$env.getAPIEndPoint()}jbl/v1/event/${eventId}/requirement?format=json`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        requirements: [
          {
            id,
            position
          }
        ]
      }
    };

    return this.$http(data);
  }

  addShiftRequirements(eventId, requirements) {
    const data = {
      method: "POST",
      url: `${this.$env.getAPIEndPoint()}jbl/v1/event/${eventId}/requirement?format=json`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        requirements
      }
    };

    return this.$http(data);
  }

  removeShiftRequirement(eventId, id) {
    console.log("removeShiftRequirement");
    console.dir(eventId);
    console.dir(id);
    const data = {
      method: "DELETE",
      url: `${this.$env.getAPIEndPoint()}jbl/v1/event/${eventId}/requirement?format=json`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        requirementId: id
      }
    };

    return this.$http(data);
  }

  getAllShiftRequirements() {
    const data = {
      method: "GET",
      url: `${this.$env.getAPIEndPoint()}jbl/v1/requirement?format=json`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      }
    };

    return this.$http(data);
  }

  getShiftRequirements(eventId) {
    const data = {
      method: "GET",
      url: `${this.$env.getAPIEndPoint()}jbl/v1/event/${eventId}/requirement?format=json`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      }
    };

    return this.$http(data);
  }

  deleteShift(shift) {
    var _this = this;

    //console.log("deleteShift");
    //console.dir(shift);

    let req = {
      method: "DELETE",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        id: shift.id
      }
    };

    return _this.$http(req);
  }

  bulkDeleteShifts(shiftIds) {
    var _this = this;

    console.log("bulkDeleteShifts");
    console.dir(shiftIds);

    let req = {
      method: "DELETE",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts/bulk-delete?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {ids: shiftIds}
    };

    return _this.$http(req);
  }

  updateExistingShift(shift, isChecked) {
    var _this = this;

    console.log("updateNewShiftForExistingEvent");
    console.dir(shift);

    let sendNotification = null;

    if (isChecked === true) {
      sendNotification = false;
    } else {
      sendNotification = true;
    }

    let req = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts?format=json&sendNotification=" + sendNotification,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: shift
    };

    return _this.$http(req);
  }

  createNewShiftForExistingEventBulk(payload) {
    var _this = this;

    const data = payload;

    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts/bulk-create?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data
    };

    return _this.$http(req);
  }

  createNewShiftForExistingEvent(jobbleId, shifts, event, shift) {
    var _this = this;

    console.log("createNewShiftForExistingEvent");
    console.dir(shift);
    console.dir(jobbleId);
    console.dir(event);

    const data = {
      jobbleId: jobbleId,
      contactInfo: {
        city: shift.contactInfo.city,
        state: shift.contactInfo.state,
        streetLine1: shift.contactInfo.streetLine1,
        streetLine2: null,
        zipCode: shift.contactInfo.zipCode,
        lat: shift.contactInfo.lat,
        lng: shift.contactInfo.lng
      },
      timeInterval: {
        startTime: shift.timeInterval.startTime,
        endTime: shift.timeInterval.endTime
      },
      overnight: shift.overnight
    };

    if (shift.unpaidBreak && shift.unpaidBreak > 0) {
      data.unpaidBreak = shift.unpaidBreak;
    }

    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data
    };

    return _this.$http(req);
  }

  updateExistingDraft(jobbleId, shifts, event) {
    var _this = this;

    console.log("updateExistingDraft");
    console.dir(jobbleId);
    console.dir(shifts);

    var id = null;

    if (jobbleId) {
      id = jobbleId;
    } else {
      id = event.jid;
    }

    var jobbleShiftsData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "/bulk-update?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          shifts: shifts
        }
      }
    };

    return _this.$http(jobbleShiftsData);
  }

  //_this.updateJobblePoolData();
  //_this.updateSubEventData();

  editOpenings() {
    var _this = this;

    var addOpeningsData = {
      method: "POST",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        _this.event.subEvents[0].deduppedJobbles[0].id +
        "/add-positions?format=json&conf=web&numberOfPositions=" +
        (_this.event.numberOfOpenings - _this.event.numberOfOpeningsOrigin),
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {}
    };

    _this.$http(addOpeningsData).then(
      function (response) {
        if (response.data.status !== "error") {
          _this.updateSubEventData();
        }
      },
      function (response) {
        console.log(response.data);
      }
    );
  }

  updateEventData(jobblePool, event) {
    var _this = this;

    var eventData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + jobblePool.eventId + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        name: event.name,
        eventType: 1,
        description: event.jobble_details
      }
    };

    return _this.$http(eventData);
  }

  extendJob(payload) {
    var _this = this;

    console.log("extendJob");
    console.dir(payload);

    var payload = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + payload.jobbleIdExtend + "/extend",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        weeks: payload.weeks
      }
    };

    return _this.$http(payload);
  }

  setJobSchedule(jobbleId, weeks) {
    var _this = this;

    var payload = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbleId + "/schedule",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        weeks: weeks
      }
    };

    return _this.$http(payload);
  }

  updateAutoHire(event, payload) {
    var _this = this;

    var eventData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + event.id + "?format=json&conf=web&fields=id,autoAccept,autoManage",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: payload
    };

    return _this.$http(eventData);
  }

  reverseReject(id) {
    var _this = this;
    let data = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/applications/reverseReject/" +
        id +
        "?format=json&fields=id,applicationStatus.id,applicationStatus.name,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.username,applicant.numberOfCompletedJobbles",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {applicationId: id}
    };

    return _this.$http(data);
  }

  updateJobblePoolData(jobblePool, event) {
    console.log("updateJobblePoolData");
    console.dir(jobblePool);
    console.dir(event);

    var _this = this;

    var jobblePoolData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobblePool.jobbles[0].id + "/bulk-update?format=json",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          jobbleType: event.jobble_type,
          description: event.jobble_details,
          payPerHour: event.hourly_rate * 100,
          dressCode: event.dress_code
        }
      }
    };

    return _this.$http(jobblePoolData);
  }

  saveQuestionsToEvent(eid, questions, event) {
    var _this = this;

    console.log("saveQuestionsToEvent");
    console.dir(eid);
    console.dir(questions);
    console.dir(event);

    var eventData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + eid + "?format=json&conf=web&fields=id,isPublished",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        surveyQuestions: questions,
        name: event.name,
        eventType: 1,
        description: event.jobble_details
      }
    };

    return _this.$http(eventData);
  }

  saveEventPayRate(jobble_id, pay) {
    pay = parseFloat(pay);

    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false&creationProcess=true",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          payPerHour: pay * 100,
          isPublished: true,
          creationProcess: true
        }
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventHiringManager(jobble_id, hiring_manager) {
    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          manager: hiring_manager
        }
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventPositionType(jobble_id, position_type) {
    console.log("jobble_id");
    console.dir(jobble_id);
    console.dir(position_type);

    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          jobbleType: position_type
        }
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventName(event_id, name) {
    var eventData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web&fields=id,isPublished&aclProcess=false&marshal=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        name: name
      }
    };

    return this.$http(eventData);
  }

  saveW2Status(event) {
    console.log("saveW2Status");
    console.dir(event);

    var eventData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event.id + "?format=json&conf=web&fields=id,isPublished&aclProcess=false&marshal=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        isW2: event.is_w2
      }
    };

    return this.$http(eventData);
  }

  saveEventLongTermShortTerm(event_id, isLongTerm) {
    let data = {
      isLongTerm
    };

    if (!isLongTerm) {
      data.weeks = null;
    }

    console.log("saveEventLongTermShortTerm");
    console.dir(data);

    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data
    };

    return this.$http(jobblePoolData);
  }

  saveEventLongTermWeeks(event_id, weeks) {
    console.log("saveEventLongTermWeeks");
    console.dir(event_id);
    console.dir(weeks);

    if (!weeks || angular.isUndefined(weeks) || weeks === "undefined" || weeks === 0 || weeks === "0") {
      console.log("setting default weeks");
      weeks = "11";
    }

    console.log("weeks right before request");
    console.dir(weeks);

    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web&aclProcess=false&marshal=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        weeks: weeks
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventArrivalInstructions(event_id, arrivalInstructions, onsiteManagerName, onsiteManagerNumber) {
    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        arrivalInstructions,
        onsiteManagerName,
        onsiteManagerNumber
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventDescription(event_id, description) {
    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        description
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventDescriptionToJobbles(jobble_id, description) {
    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          description
        }
      }
    };

    return this.$http(jobblePoolData);
  }

  saveEventDressCode(jobble_id, dress_code) {
    var jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          dressCode: dress_code
        }
      }
    };

    return this.$http(jobblePoolData);
  }

  validateWorflowShift(shift, generator) {
    if (!shift || !shift.startDate || !shift.startTime || !shift.endDate || !shift.endTime) {
      return false;
    }
    const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
    const endDate = new Date(`${shift.endDate} ${shift.endTime}`);
    if (startDate.getTime() - new Date().getTime() <= 0) {
      console.error("Start date in the past");
      return false;
    }
    if (this.development_env !== "dev" && startDate.getTime() - new Date().getTime() <= GRACE_PERIOD) {
      console.error("Start date is less than 3 days from now");
      return false;
    }
    if (endDate.getTime() - startDate.getTime() <= 0) {
      console.error("End date after start date");
      return false;
    }
    if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
      console.error("Shift is longer than 24 hours");
      return false;
    }
    if (this.development_env !== "dev" && endDate.getTime() - startDate.getTime() < 1000 * 60 * 60 * 6) {
      console.error("Shift is shorter than 6 hours");
      return false;
    }
    return true;
  }

  validateLongTermGenerator(shift) {
    console.log("this.development_env", this.development_env);

    if (!shift || !shift.startDate || !shift.startTime || !shift.endTime) {
      return false;
    }

    const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
    let endDate = new Date(`${shift.startDate} ${shift.endTime}`);

    if (endDate.getTime() - startDate.getTime() <= 0) {
      endDate = new Date(endDate.getTime() + 1000 * 60 * 60 * 24);
    }

    const shiftLength = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);

    if (startDate.getTime() - new Date().getTime() <= 0) {
      console.error("Start date in the past");
      return false;
    }

    if (startDate.getTime() - new Date().getTime() <= GRACE_PERIOD) {
      console.error("Start date is less than 3 days from now");
      return false;
    }

    if (!shift.daysOfWeek || !shift.daysOfWeek.length || shift.daysOfWeek.length < 3) {
      console.error("Less than 3 days in the week");
      return false;
    }

    if (this.development_env !== "dev" && shiftLength < 6) {
      console.error("Less than 6 hours in the shift");
      return false;
    }

    // if (endDate.getTime() - startDate.getTime() <= 0) {
    //     console.error("End date after start date");
    //     return false;
    // }

    // if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
    //     console.error("Shift is longer than 24 hours");
    //     return false;
    // }

    return true;
  }

  validateWorflowShiftsNonOverlapping(shifts) {
    if (!shifts || !shifts.length) return false;

    if (shifts.length === 1) return true;

    let mappedShifts = shifts.map((shift) => {
      return {
        startDate: new Date(`${shift.startDate} ${shift.startTime}`),
        endDate: new Date(`${shift.endDate} ${shift.endTime}`)
      };
    });

    mappedShifts = mappedShifts.sort((a, b) => {
      return a.startDate.getTime() - b.startDate.getTime();
    });

    let overLapping = false;

    mappedShifts.forEach((shift, i) => {
      if (i === 0) return;

      let prevShift = mappedShifts[i - 1];

      if (shift.startDate.getTime() < prevShift.endDate.getTime()) overLapping = true;
    });

    return !overLapping;
  }

  bulkUpdateJob(jid, eventObj) {
    var _this = this;

    var jobbleForDB = {
      name: eventObj.name,
      payPerHour: parseInt(eventObj.hourly_rate * 100),
      description: eventObj.jobble_details,
      dressCode: eventObj.dress_code,
      jobbleType: eventObj.jobble_type,
      isPublished: true,
      subEvent: {
        name: eventObj.name,
        contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
        event: {
          name: eventObj.name,
          description: eventObj.jobble_details,
          eventType: 1,
          isPublished: false,
          timeToHire: eventObj.timeToHire,
          company: this.$auth.getUserData().company.id,
          isSourcingPost: null
        }
      },

      shifts: []
    };

    if (eventObj.typeOfJobPosting === "source") {
      jobbleForDB.subEvent.event.isSourcingPost = true;
    } else {
      jobbleForDB.subEvent.event.isSourcingPost = false;
    }

    console.log("eventObj.cloudsForJobblePost");
    console.dir(eventObj.cloudsForJobblePost);

    try {
      for (var i = 0; i < eventObj.timeIntervalsArray.length; i++) {
        var shift = {
          timeInterval: {
            startTime: eventObj.timeIntervalsArray[i].startDateAndTimeForDB,
            endTime: eventObj.timeIntervalsArray[i].endDateAndTimeForDB
          },
          contactInfo: eventObj.timeIntervalsArray[i].contactInfo
        };
        jobbleForDB.shifts.push(shift);
      }
    } finally {
      var jobblePoolData = {
        method: "PUT",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jid + "/bulk-update?format=json&fields=id",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.$auth.getAccessToken()
        },
        data: {jobble: jobbleForDB}
      };

      return _this.$http(jobblePoolData);
    }
  }

  markJobAsPublished(jobblePool, event, questions, ids) {
    var _this = this;
    console.log("markJobAsPublished");
    console.dir(jobblePool);
    console.dir(event);
    let id = null;
    if (jobblePool.eventId) {
      id = jobblePool.eventId;
    } else {
      id = jobblePool.data.id;
    }
    var eventData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + id + "?format=json&conf=web&fields=id,isPublished",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        surveyQuestions: questions,
        isCancelled: false,
        isCompleted: false
      }
    };
    return _this.$http(eventData);
  }

  markJobblesAsPublished(jobblePool, event, status) {
    var id = null;

    var _this = this;

    if (jobblePool.jobbles) {
      id = jobblePool.jobbles[0].id;
    } else if (jobblePool.data) {
      id = jobblePool.data.subEvents[0].deduppedJobbles[0].id;
    } else {
      id = jobblePool;
    }
    console.log("markJobblesAsPublished");
    console.dir(status);
    console.dir(angular.isUndefined(status));

    if (status === true) {
      console.log("do nothing");
    } else if (angular.isUndefined(status) || status === null) {
      console.log("are we undefined?");
      console.dir(status);
      status = true;
    } else {
      status = false;
    }

    console.log("what is the status");
    console.dir(status);

    var jobblePoolData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "/bulk-update?format=json&fields=id,isPublished",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          isPublished: status
        }
      }
    };

    return _this.$http(jobblePoolData);
  }

  publishEvent(jobble_id, status) {
    const jobblePoolData = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&fields=id,isPublished&creationProcess=true",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          isPublished: status,
          creationProcess: true
        }
      }
    };

    return this.$http(jobblePoolData);
  }

  pushTeamsOntoEvent(event, ids, isCreation, new_load) {
    var _this = this;

    if (new_load) {
      var eventPostedToTeamsData = {
        method: "POST",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.$auth.getAccessToken()
        },
        data: {
          event: event,
          circles: ids,
          forCircleOnly: true
        }
      };
    } else {
      if (isCreation) {
        var eventPostedToTeamsData = {
          method: "POST",
          url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Bearer " + _this.$auth.getAccessToken()
          },
          data: {
            event: event.eventId,
            subEvent: event.subEventsId,
            jobbles: [event.jobbles[0].id],
            circles: ids,
            forCircleOnly: true
          }
        };
      } else {
        var eventPostedToTeamsData = {
          method: "POST",
          url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Bearer " + _this.$auth.getAccessToken()
          },
          data: {
            event: event.id,
            subEvent: event.subEvents[0].id,
            jobbles: [event.subEvents[0].deduppedJobbles[0].id],
            circles: ids,
            forCircleOnly: true
          }
        };
      }
    }

    return _this.$http(eventPostedToTeamsData);
  }

  saveQuestionsDuringCreation(questions) {
    var _this = this;
  }

  getShiftRoster(shiftId) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/shifts/" +
      shiftId +
      "?format=json&fields=contactInfo.lat,contactInfo.lng,contactInfo.state,contactInfo.streetLine1,contactInfo.city,contactInfo.zipCode,timeInterval.startTime,timeInterval.endTime,contactInfo.place.timeZoneId";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getShift(shiftId) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/shifts/" +
      shiftId +
      "?format=json&fields=contactInfo.state,contactInfo.streetLine1,contactInfo.city,contactInfo.zipCode,timeInterval.startTime,timeInterval.endTime";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  getAcceptedApplicationsTrimmedRecordTimes(subEventId, maxCount = 200, offset = 0) {
    var url =
      this.$env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      subEventId +
      "/applications?format=json&max=" +
      maxCount +
      "&status=1&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.email,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.shifts.id,jobble.shifts.checkInCoord,jobble.shifts.checkOutCoord,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.noShow,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime";
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };
    return this.$http(req);
  }

  updateShiftCheckInTime(date, application) {
    var _this = this;

    var data = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + application.currentShift.id + "/?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {managerCheckInTime: date}
    };

    return _this.$http(data);
  }

  updateShiftCheckOutTime(date, application) {
    var _this = this;
    var data = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + application.currentShift.id + "/?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {managerCheckOutTime: date}
    };
    return _this.$http(data);
  }

  connect(usersAndApplications) {
    var card = this.$localStorage.logged_user.company.paymentInfos[0].cardToken;
    var req = {
      method: "POST",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/companies/bulk-connect?format=json&amount=0&custUsername=" +
        this.$localStorage.logged_user.username +
        "&note=Connection",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token
      },
      data: {
        usersAndApplications: usersAndApplications,
        card: card
      }
    };
    return this.$http(req);
  }

  rateOrReview(ratingsArray) {
    var _this = this;

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web&fields=rate",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token
      },
      data: {ratings: ratingsArray}
    };

    return this.$http(req);
  }

  reOpenEvent(id) {
    var _this = this;

    var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + id + "?conf=web&format=json&fields=id";

    var req = {
      method: "PUT",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
      },

      data: {
        isClosed: false,
        isCompleted: false
      }
    };

    return _this.$http(req);
  }

  updateQuestion(data) {
    var _this = this;
    let url = _this.$env.getAPIEndPoint() + "jbl/v1/events/" + data.event_id + "?format=json&conf=web";
    var req = {
      method: "PUT",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
      },
      data: {surveyQuestions: data.questions}
    };
    return _this.$http(req);
  }

  updatePostType(data) {
    var _this = this;
    let url = _this.$env.getAPIEndPoint() + "jbl/v1/events/" + data.event_id + "?format=json&conf=web&fields=id,isSourcingPost";
    var req = {
      method: "PUT",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
      },

      data: data
    };
    return _this.$http(req);
  }

  deleteSurveyQuestions(payload) {
    var _this = this;
    let url = _this.$env.getAPIEndPoint() + "jbl/v1/events/delete-questions?format=json";
    var req = {
      method: "POST",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
      },
      data: payload
    };
    return _this.$http(req);
  }

  editEventOpenings(jobble_id, delta) {
    var addOpeningsData = {
      method: "POST",
      url:
        this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        jobble_id +
        "/" +
        (delta >= 0 ? "add" : "rm") +
        "-positions?format=json&fields=id&conf=web&creationProcess=true&sendSlackNotification=false&numberOfPositions=" +
        Math.abs(delta),
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(addOpeningsData);
  }

  /** creating orders **/
  create_jobble_pool(order, jts) {
    var _this = this;
    let jobbleForDB = _this.create_jobble_for_db(order);
    let data = {};
    console.log("order right before posting");
    console.dir(order.teams_for_order);
    if (order.teams_for_order.length > 0) {
      data.forCircleOnly = true;
      data.circles = order.teams_for_order;
      data.jobble = jobbleForDB;
    } else {
      data.jobble = jobbleForDB;
    }
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&verbosity=1&numberPosition=" + order.openings,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: data
    };
    return this.$http(req);
  }

  format_addresses(order) {
    var _this = this;
    let address_for_mobile = {pickup: null, dropoff: null};
    address_for_mobile.pickup = order.pickup.contactInfo.streetLine1 + ", " + order.pickup.contactInfo.city + ", " + order.pickup.contactInfo.state;
    address_for_mobile.dropoff =
      order.dropoff.contactInfo.streetLine1 + ", " + order.dropoff.contactInfo.city + ", " + order.dropoff.contactInfo.state;
    return address_for_mobile;
  }

  format_dates(order) {
    var _this = this;
    let dates_formatted = {};
    let ptz = null;
    let dtz = null;
    if (order.is_clone) {
      ptz = order.pickup.contactInfo.place.timeZoneId;
      dtz = order.dropoff.contactInfo.place.timeZoneId;
    } else {
      ptz = order.pickup.time_zone_id;
      dtz = order.dropoff.time_zone_id;
    }
    dates_formatted.pickup = moment(order.pickup.timeInterval.startTime).format("ddd MMM DD HH:mm zz YYYY");
    dates_formatted.dropoff = moment(order.dropoff.timeInterval.startTime).format("ddd MMM DD HH:mm zz YYYY");
    let nowTherePickup = null;
    let nowThereDropOff = null;
    let timeInSecPickup = null;
    let timeInSecDropoff = null;
    let pickupOffset = null;
    let dropoffOffset = null;
    let day_light_savings = moment(order.pickup.timeInterval.startTime).isDST();

    let zone = moment.tz.zone(moment.tz.guess());
    let userTimeZoneName = moment.tz.guess();
    let now = moment.tz(userTimeZoneName);
    let user_offset = -zone.offsets[zone.offsets.length - 1];
    nowTherePickup = moment.tz(order.pickup.time_zone);
    nowThereDropOff = moment.tz(order.dropoff.time_zone);
    timeInSecPickup = (parseInt(now.utcOffset(), 10) - parseInt(nowTherePickup.utcOffset())) * 60;
    timeInSecDropoff = (parseInt(now.utcOffset(), 10) - parseInt(nowThereDropOff.utcOffset())) * 60;
    pickupOffset = order.pickup.raw_offset / 60000;
    dropoffOffset = order.dropoff.raw_offset / 60000;
    dates_formatted.pickup_fixed = moment(order.pickup.timeInterval.startTime)
      .add(user_offset - pickupOffset, "minutes")
      .format("ddd MMM DD HH:mm zz YYYY");
    dates_formatted.pickup_fixed_db = moment(order.pickup.timeInterval.startTime)
      .add(user_offset - pickupOffset, "minutes")
      .format();
    dates_formatted.pickup_fixed_end_db = moment(order.pickup.timeInterval.endTime)
      .add(user_offset - pickupOffset, "minutes")
      .format();
    dates_formatted.dropoff_fixed = moment(order.dropoff.timeInterval.startTime)
      .add(user_offset - dropoffOffset, "minutes")
      .format("ddd MMM DD HH:mm zz YYYY");
    dates_formatted.dropoff_fixed_db = moment(order.dropoff.timeInterval.startTime)
      .add(user_offset - dropoffOffset, "minutes")
      .format();
    dates_formatted.dropoff_fixed_end_db = moment(order.dropoff.timeInterval.endTime)
      .add(user_offset - dropoffOffset, "minutes")
      .format();
    if (order.pickup.time_zone_id === "America/Phoenix" && day_light_savings === true) {
      dates_formatted.pickup_fixed = moment(dates_formatted.pickup_fixed_db)
        .add(1, "hours")
        .tz(order.pickup.time_zone_id)
        .format("ddd MMM DD HH:mm zz YYYY");
      dates_formatted.pickup_fixed_db = moment(dates_formatted.pickup_fixed_db).add(1, "hours").format();
      dates_formatted.pickup_fixed_end_db = moment(dates_formatted.pickup_fixed_end_db).add(1, "hours").format();
      dates_formatted.dropoff_fixed = moment(dates_formatted.dropoff_fixed_db)
        .add(1, "hours")
        .tz(order.dropoff.time_zone_id)
        .format("ddd MMM DD HH:mm zz YYYY");
      dates_formatted.dropoff_fixed_db = moment(dates_formatted.dropoff_fixed_db).add(1, "hours").format();
      dates_formatted.dropoff_fixed_end_db = moment(dates_formatted.dropoff_fixed_end_db).add(1, "hours").format();
    }
    let s = moment(dates_formatted.pickup_fixed_db);
    let e = moment(dates_formatted.dropoff_fixed_db);
    let ss = moment(order.pickup.timeInterval.startTime);
    let ee = moment(order.dropoff.timeInterval.startTime);
    let pst = s.diff(ss, "minutes");
    let dst = e.diff(ee, "minutes");

    if (pst > 0) {
      dates_formatted.pickup_fixed = moment(dates_formatted.pickup_fixed).subtract(pst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
      dates_formatted.dropoff_fixed = moment(dates_formatted.dropoff_fixed).subtract(dst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
    } else {
      dates_formatted.pickup_fixed = moment(dates_formatted.pickup_fixed).subtract(pst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
      dates_formatted.dropoff_fixed = moment(dates_formatted.dropoff_fixed).subtract(dst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
    }

    return dates_formatted;
  }

  push_to_teams(jobble_pool, order) {
    var _this = this;
    let data = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        event: jobble_pool.eventId,
        subEvent: jobble_pool.subEventsId,
        jobbles: [jobble_pool.jobbles[0].id],
        circles: order.teams_for_order,
        forCircleOnly: true
      }
    };

    return _this.$http(data);
  }

  create_jobble_for_db(order, jts) {
    var _this = this;
    let dates = _this.format_dates(order);
    let addresses = _this.format_addresses(order);
    let jt = null;
    if (order.jobble_type_id_for_backend) {
      jt = order.jobble_type_id_for_backend;
    } else {
      jt = 44;
    }
    let company_id = _this.$auth.getUserData().company.id;
    let survey_questions = [
      {
        question: "Why are you a good fit?",
        questionType: 1,
        editing: false,
        name: "Question 1"
      }
    ];
    if (!order.number) {
      order.number = _this.generate_code();
    }
    order.pickup.timeInterval.startTime = dates.pickup_fixed_db;
    order.pickup.timeInterval.endTime = dates.pickup_fixed_end_db;
    order.dropoff.timeInterval.startTime = dates.dropoff_fixed_db;
    order.dropoff.timeInterval.endTime = dates.dropoff_fixed_end_db;

    let jobbleForDB = {
      name: order.name,
      payPerHour: order.payment_formatted,
      description: order.description,
      dressCode: "--",
      jobbleType: jt,
      isPublished: false,
      pickupLocation: order.pickup.location,
      dropoffLocation: order.dropoff.location,
      pickupAddress: addresses.pickup,
      dropoffAddress: addresses.dropoff,
      pickupTime: dates.pickup_fixed,
      dropoffTime: dates.dropoff_fixed,
      pickupContactInfo: order.pickup.contact,
      dropoffContactInfo: order.dropoff.contact,
      //deliveryContactInfo: order.hiring_manager,
      subEvent: {
        name: order.name,
        contactInfo: order.pickup.contactInfo,
        event: {
          name: order.name,
          description: order.description,
          eventType: 1,
          company: company_id,
          surveyQuestions: survey_questions,
          orderNumber: order.number,
          isOrder: true
        }
      },
      shifts: [
        {
          timeInterval: order.pickup.timeInterval,
          contactInfo: order.pickup.contactInfo,
          location: order.pickup.location,
          description: order.pickup.instructions,
          padding: order.pickup.padding,
          deliveryContactInfo: order.pickup.contact
        },
        {
          timeInterval: order.dropoff.timeInterval,
          contactInfo: order.dropoff.contactInfo,
          location: order.dropoff.location,
          description: order.dropoff.instructions,
          padding: order.dropoff.padding,
          deliveryContactInfo: order.dropoff.contact
        }
      ]
    };
    return jobbleForDB;
  }

  mark_order_as_published(jobble_pool) {
    let id = null;
    if (jobble_pool.jobbles) {
      id = jobble_pool.jobbles[0].id;
    }
    var _this = this;
    var jobblePoolData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "/bulk-update?format=json&fields=id,isPublished",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          isPublished: true
        }
      }
    };
    return _this.$http(jobblePoolData);
  }

  updateEventInfoForOrder(data) {
    var _this = this;
    let event_data = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + data.id + "?format=json&conf=web&fields=id",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        name: data.name,
        description: data.description
      }
    };

    return _this.$http(event_data);
  }

  updateSubEventInfoForOrder(data) {
    var _this = this;
    let event_data = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + data.id + "?format=json&conf=web&fields=id",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        name: data.name,
        description: data.description
      }
    };
    return _this.$http(event_data);
  }

  updateJobbleInfoForOrder(data) {
    var _this = this;
    var jobble_data = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.id + "/bulk-update?format=json&fields=id",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        jobble: {
          description: data.description,
          payPerHour: data.pay * 100,
          pickupContactInfo: data.pickup_contact,
          dropoffContactInfo: data.dropoff_contact
        }
      }
    };

    return _this.$http(jobble_data);
  }

  generate_code() {
    var _this = this;
    let code = "JBLO-" + _this.$localStorage.logged_user.company.id + "-" + moment().format("SSSS");
    return code;
  }

  getShiftsInSamePosition(shiftId) {
    var _this = this;

    var url = _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "/shiftInformationToPay?format=json";

    var req = {
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      }
    };

    return this.$http(req);
  }

  load_eta_data(event, jobble) {
    var _this = this;
    var url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/jobbles/" +
      jobble +
      "?format=json&fields=id,pickupLocation,dropoffLocation,pickupAddress,dropoffAddress,pickupTime,dropoffTime,deliveryContactInfo,pickupContactInfo,dropoffContactInfo,startTimeFormattedLoc,endTimeFormattedLoc,currentLocation,currentLocation.lat,currentLocation.lng,currentLocation.lastUpdateFront,shifts.id,shifts.pickupEta,shifts.dropoffEta,shifts.timeInterval.startTime,shifts.location,shifts.timeInterval.endTime,shifts.contactInfo.id,shifts.contactInfo.streetLine1,shifts.contactInfo.place.timeZoneId,shifts.contactInfo.city,shifts.contactInfo.state,shifts.contactInfo.zipCode,shifts.checkInTime,shifts.checkOutTime,shifts.contactInfo.place.timeZoneName";
    var req = {
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      }
    };
    return this.$http(req);
  }

  promote_event(id) {
    var _this = this;

    let data = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/promote-pool",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        id: id
      }
    };

    return _this.$http(data);
  }

  updateActualMinutesWorkedForShift(id, minutes) {
    var _this = this;

    let req = {
      method: "PUT",

      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&conf=web&fields=id",

      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },

      data: {
        actualMinutesWorked: minutes
      }
    };

    return _this.$http(req);
  }

  adjustTimeZone(zipCode) {
    return new Promise((resolve) => {
      const mockShift = {
        contactInfo: {
          zipCode
        }
      };

      this.$security.getEventShiftTimezoneInfo(mockShift).then((response) => {
        console.log("getEventShiftTimezoneInfo");
        console.dir(response);
        const zone = moment.tz.zone(moment.tz.guess());
        console.log("manager zone");
        console.dir(zone);
        let browserTimeZone = moment.tz.guess();
        var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
        console.dir(eventMangerOffsets);
        var eventOffsets = response.data[0].rawOffset / 60000;
        var state = response.data[0].statePostalCode;
        let timeZone = response.data[0].timeZoneId;

        const timeZoneDifference = eventMangerOffsets - eventOffsets;

        return resolve({timeZone, timeZoneDifference, state, browserTimeZone});
      });
    });
  }

  adjustTimeZones(shift, timeZone, timeZoneDifference, state, remove) {

    if (remove) {
      timeZoneDifference = timeZoneDifference * -1;
    }

    let userTimeZoneName = moment.tz.guess();
    let jobDST = moment().tz(timeZone).isDST();
    let browserUserDST = moment().tz(userTimeZoneName).isDST();

    timeZoneDifference = 0;

    if (browserUserDST != jobDST && state != "AZ" && state != "HI") {
      timeZoneDifference = timeZoneDifference + 60;
    }

    console.log("timeZoneDifference------------------");
    console.dir(timeZoneDifference);

    console.log("log before saving state date");
    console.dir(shift);

    shift.startDateAndTimeForDB = moment.tz(`${shift.startDate} ${shift.startTime}`, "M/D/YYYY h:mm a", timeZone);
    shift.endDateAndTimeForDB = moment.tz(`${shift.endDate} ${shift.endTime}`, "M/D/YYYY h:mm a", timeZone);

    //shift.startDateAndTimeForDB = moment(`${shift.startDate} ${shift.startTime}`).add(timeZoneDifference, "minutes").format();
    //shift.endDateAndTimeForDB = moment(`${shift.endDate} ${shift.endTime}`).add(timeZoneDifference, "minutes").format();

    let startTime = shift.startDateAndTimeForDB.format();
    let endTime = shift.endDateAndTimeForDB.format();

    //console.log("adjustTimeZones");
    //console.dir(startTime);
    //console.dir(endTime);

    return {
      startTime,
      endTime
    };
  }

  markUserAsNowShowForShift(id, value) {
    let req = {
      method: "PUT",

      url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&conf=web&fields=id",

      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },

      data: {
        noShow: value,
        actualMinutesWorked: 0
      }
    };

    return this.$http(req);
  }

  markUserAsNowShowForShiftNew(id, value) {
    let data = {
      noShow: value
    };

    if (value) {
      data.actualMinutesWorked = 0;
    }

    let req = {
      method: "PUT",

      url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&conf=web&fields=id",

      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },

      data
    };

    return this.$http(req);
  }

  payUsersByShift(data) {
    var _this = this;

    console.log("paying users");
    console.dir(data);

    let req = {
      method: "POST",

      url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",

      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },

      data: data
    };

    return _this.$http(req);
  }

  bulkUnpublish(data) {
    var _this = this;

    let req = {
      method: "POST",

      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-unpublish?format=json",

      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },

      data: {events: data}
    };

    return _this.$http(req);
  }

  bulkPublish(data) {
    var _this = this;

    let req = {
      method: "POST",

      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-publish?format=json",

      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },

      data: {events: data}
    };

    return _this.$http(req);
  }

  bulkCloseEvent(data) {
    var _this = this;

    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/events/close-event?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {events: data}
    };

    return this.$http(req);
  }

  bulkArchive(data) {
    var _this = this;
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-archive?format=json",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        events: data
      }
    };

    return _this.$http(req);
  }

  bulkRestore(data) {
    var _this = this;
    console.log("bulkRestore data");
    console.dir(data);
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-restore?format=json",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        events: data
      }
    };

    return _this.$http(req);
  }

  bulkReopen(data) {
    var _this = this;
    console.log("bulkReopen data");
    console.dir(data);
    let req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/reopen-event?format=json",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.$auth.getAccessToken()
      },
      data: {
        events: data
      }
    };

    return _this.$http(req);
  }

  getOpenings(eventId) {
    let url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + eventId + "?format=json&fields=id,numberOfOpenings,openings";

    let req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      },
      data: {}
    };

    return this.$http(req);
  }

  getElasticSearchJobs(data) {
    console.log("getElasticSearchJobs");
    console.dir(data);

    let url = this.$env.getElasticSearchEventsAPIEndPoint() + "ondemand/jobs/";

    if (!data) {
      data = {};
      data.offset = 10;
      url = "?limit=10&offset=0";
    } else {
      url = url + "?";
      url = url + "limit=" + data.limit + "&offset=" + data.offset;

      if (data.isPublished) {
        url = url + "&isPublished=" + data.isPublished;
      }

      if (data.isCancelled) {
        url = url + "&isCancelled=" + data.isCancelled;
      }

      if (data.isDraft) {
        url = url + "&isDraft=" + data.isDraft;
      }

      if (data.isComplited) {
        url = url + "&isCompleted=" + data.isComplited;
      }

      if (data.isCompleted) {
        url = url + "&isComplited=" + data.isCompleted;
      }

      if (data.search) {
        url = url + "&search=" + data.search;
      }

      if (data.name) {
        url = url + "&name=" + data.name;
      }

      if (data.eventId) {
        url = url + "&eventId=" + data.eventId;
      }

      if (data.jobbleType) {
        url = url + "&jobbleType=" + data.jobbleType;
      }

      if (data.direction) {
        url = url + "&direction=" + data.direction;
      }

      if (data.sort) {
        url = url + "&sort=" + data.sort;
      }
    }

    let req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken()
      }
    };

    return this.$http(req);
  }

  dayLightSavingsCalculation(dateCreated, shift, returnType, fromHTML) {
    let result;
    let isDSTstartTime = moment(shift.timeInterval.startTime).isDST();
    let isDSTendTime = moment(shift.timeInterval.endTime).isDST();
    let isDSTDateCreated = moment(dateCreated).isDST();
    let isDSTNow = moment().isDST();
    let timeZone = shift.contactInfo.place.timeZoneId;

    if (returnType === "startTime") {
      if (isDSTDateCreated && isDSTNow && !isDSTstartTime) {
        shift.startTimeFormattedWithDSTAdjustment = moment(shift.startTimeFullFormat).add(1, "hours").tz(timeZone).format("h:mmA");
        result = shift.startTimeFormattedWithDSTAdjustment;
      } else {
        result = shift.startTimeFormatted;
      }
    } else if (returnType === "endTime") {
      if (isDSTDateCreated && isDSTNow && !isDSTendTime) {
        shift.endTimeFormattedWithDSTAdjustment = moment(shift.endTimeFullFormat).add(1, "hours").tz(timeZone).format("h:mmA");
        result = shift.endTimeFormattedWithDSTAdjustment;
      } else {
        result = shift.endTimeFormatted;
      }
    } else if (returnType === "startDate") {
      result = shift.startDateFormatted;
    }

    return result;
  }
}

EventsService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "tracking", "$timeout"];



// WEBPACK FOOTER //
// ./client/app/services/events.js